import component from './EditTravelPolicy.vue';
export const EDIT_TRAVEL_POLICY = "editTravelPolicy";

export default{
    id: EDIT_TRAVEL_POLICY,
    component,
}